import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, Input, OnInit } from '@angular/core';
import { UtilityService } from '../../../core/services/utility.service';

//services
import { TimecardService } from 'src/app/pages/timecard/services/timecard.service';

@Component({
  selector: 'app-add-timecard-attachment-modal',
  templateUrl: './add-timecard-attachment-modal.component.html',
  styleUrls: ['./add-timecard-attachment-modal.component.css'],
})
export class AddTimecardAttachmentModalComponent implements OnInit {
  @Input() row: any;
  @Input() readOnly: number;
  @Input() reviewModal: boolean;
  formData: { [key: string]: any } = {};
  newFiles: any[] = [];
  savedFiles: any[] = [];
  fileData: any[] = [];
  uniqueAttchID: any;
  alert: any = null;
  validComboDrag: any;
  dragFiles: any;

  constructor(
    public activeModal: NgbActiveModal,
    private utilityService: UtilityService,
    private timecardService: TimecardService
  ) {}

  ngOnInit(): void {
    this.uniqueAttchID = this.row.UniqueAttchID;
    if (this.row.KeyID != -1 && this.row.HasAttachments == '1') this.getAttachmentList();
  }

  getAttachmentList() {
    var rowID = this.reviewModal ? this.row.KeyID : this.row.id;
    this.timecardService.getAttachmentList(rowID).then((response: any) => {
      if (response != null) {
        this.savedFiles = this.row.savedFiles = response;
      }
    });
  }

  deleteUnsavedAttachment(file: any) {
    const index = this.row.newFiles.indexOf(file);
    this.row.newFiles.splice(index, 1);
  }

  deleteSavedAttachment(file: any) {
    if (this.row.UniqueAttchID != null) {
      this.timecardService.deleteVPAttachment(file.AttachmentID, this.row.UniqueAttchID, file.IsDatabaseDocument).then((response: any) => {
        if (response.success) this.getAttachmentList();
      });
    }
  }

  upload() {
    this.fileData = [];
    var currentUpload = this.formData.fileDrop;
    this.formData.fileDrop = [];
    if (currentUpload != null) {
      for (let i = 0; i < currentUpload.length; i++) {
        currentUpload[i].nameEdit = this.utilityService.formatAttachmentName(currentUpload[i].name);
        var n = 0;
        this.readFile(currentUpload[i], (e: any, fileName: string) => {
          setTimeout(() => {
            this.fileData.push({ data: e.target.result.toString().split(','), size: e.total, name: fileName });
            if (n == currentUpload.length - 1) {
              this.fileData.forEach((val: any) => {
                currentUpload.forEach((val2: any) => {
                  if (val2.size == val.size && val.name == val2.name) {
                    this.row.newFiles.push({ File: val.data[1], Filename: val2.nameEdit, Filedata: val2, Type: val.data[0].split('/')[0] });
                  }
                });
              });
            }
            n++;
          });
        });
      }
    }
  }

  private readFile(file: any, call: any) {
    var reader = new FileReader();
    reader.onload = (e: any) => {
      return call(e, file.name);
    };
    reader.readAsDataURL(file);
  }

  closeClicked() {
    this.activeModal.close('close');
  }

  closeAlert() {
    this.alert = null;
  }
}
